var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right"},[_c('ul',[_c('li',{staticClass:"wx"},[_c('div',{staticClass:"wx-img"},[_c('img',{attrs:{"src":_vm.img.ABOUT_IMG_QR,"alt":"","height":"140px","width":"140px"}})])]),_vm._v(" "),_c('li',{staticClass:"top",attrs:{"id":"returnTop"},on:{"click":function($event){return _vm.backTop()}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60c1e193","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/floatright.vue
// module id = null
// module chunks = 